module.exports = __webpack_public_path__ + "static/media/game.afb25f15.jpg";